module.exports = "/assets/data/1645266d62d4c16538919b4196435201-SO23.data.json";